import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-panel py-16 sm:py-20" aria-labelledby="results-title" data-id="element-147" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-148" data-mp="28ddhl9rhabqq">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-149" data-mp="2d6zvt6dainon">
          What educators using this Teacher Ready say
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-150" data-mp="2m6cur53sftv4">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={place} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-line bg-cream p-6 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-151" data-mp="2r6r6ax4lllxw" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-earth" aria-hidden="true" data-id="element-152" data-mp="3nf0oqu9c0kyx" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-153" data-mp="3ilocljlua6n2">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-154" data-mp="3doefdhs7kqoo">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-forest text-sm font-extrabold text-white" data-id="element-155" data-mp="38pl1ho90exnz">
                  {initials}
                </span>
                <span data-id="element-156" data-mp="57jo6zkrwuqf">
                  <b className="block text-sm text-ink" data-id="element-157" data-mp="58clzb1r89wf">{name}</b>
                  <small className="text-xs text-muted" data-id="element-158" data-mp="86ym72ip9k5">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}